import t from "./ReoButton.mjs";
import o from "./ReoButtonAnimate.mjs";
const m = t;
m.AnimateButton = o;
export {
  m as default
};
//# sourceMappingURL=index.mjs.map
